import React, { PureComponent } from "react";
import _ from "lodash";
import styled from "styled-components";

import { BackgroundImage } from "../components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Paragraph = styled.p`
  text-transform: uppercase;
  font-family: Lato;
  // font-family: Helvetica;
  font-weight: 700;
  font-size: 80px;
  color: ${(props) => props.fontColor || "#00"};
  text-shadow: 6px 6px rgba(0, 0, 0, 0.5);
  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

class ComingSoon extends PureComponent {
  render() {
    const { src, fontColor = "#000" } = this.props;
    console.log("ComingSoon", { src, fontColor });
    if (!_.isEmpty(src)) {
      return (
        <Container className="coming-soon">
          <BackgroundImage
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
            image={src}
          >
            <Block>
              <Paragraph fontColor={fontColor}>Coming Soon</Paragraph>
            </Block>
          </BackgroundImage>
        </Container>
      );
    }
    return (
      <Block>
        <Paragraph fontColor={fontColor}>Coming Soon</Paragraph>
      </Block>
    );
  }
}

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/containers/ComingSoon.js